import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  roleListSchema,
  type CreateRolePayload,
  type Role,
  type UpdateRolePayload,
} from '../types/role.types';

export const roleQueryKeys = {
  all: () => ['roles'] as const,
  list: () => [...roleQueryKeys.all(), 'list'] as const,
};

export const rolesQueryOptions = () =>
  queryOptions({
    queryKey: roleQueryKeys.list(),
    queryFn: async (): Promise<Role[]> => {
      const res = await apiClient.get(API.role.list);
      return roleListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createRole(payload: CreateRolePayload): Promise<void> {
  await apiClient.post(API.role.create, payload);
}

export async function updateRole(id: number, payload: UpdateRolePayload): Promise<void> {
  await apiClient.patch(API.role.update(id), payload);
}

export async function deleteRole(id: number): Promise<void> {
  await apiClient.delete(API.role.delete(id));
}
